export default __webpack_public_path__ + "static/media/wholechicken.da47185a.svg";